import { combineEpics } from 'redux-observable';

import { loadCities } from './loadCities';
import { loadStores } from './loadStores';
import { removeStore } from './removeStore';
import { editStore } from './editStore';
import { editEntity } from './editEntity';
import { removeEntity } from './removeEntity';
import { createEntity } from './createEntity';

export default combineEpics(
  loadCities,
  loadStores,
  removeStore,
  editStore,
  editEntity,
  removeEntity,
  createEntity,
);



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/index.ts